/*********** Incentives / Signups */
var incentivePopup = {
  'id': 'fn-popup-first-aid-kit-signup',
  'type': 'modal',
  'active': true,
  'pagePaths': ['.*'],
  'display': {
    'event': 'onClick',
    'selector': '.incentive-signup-link',
    'showOnlyOnce': false
  },
  'content': [
    { 'type': 'newsletter-signup',
      'text': '<h2 class="fn-popup__text--headline">Get the First Aid Kit<span class="fn-popup__text--tag">Free</span></h2><p class="fn-popup__text--subline">17 videos and 1 cheat sheet are ready for you to download...<br /></p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/first-aid-kit@2x.png" width="247" /></span>',
      'action-button': 'Send Me the Kit',
      'signup-medium': 'learn-website',
      'signup-URI': 'fn-popup-first-aid-kit-signup',
      'tags': [
        { 'id': 'tower_newsletter', 'label': "Yes, send me the kit and sign me up for the Tower newsletter. It's free, it's sent infrequently, you can unsubscribe any time - and it's loved by over <b>100,000 developers & designers</b>!", 'default': false, 'hidden': false, 'required': true, 'collectConsent': true},
        { 'id': 'incentive_firstaidkit', 'label': "", 'default': true, 'hidden': true, 'collectConsent': false}
      ],
      'consent': [
        { 'id': 'legal', 'required': true, 'text': 'I have read and accept the <a href="' + FN.siteURL('tower', 'legal/privacy-policy') + '" target="_blank">Privacy Policy</a>. <br/>I understand that I can unsubscribe at any time.'}
      ]
    },
    { 'type': 'tweet',
      'text': '<h2 class="fn-popup__text--headline">The Kit is on its Way to Your Inbox!</h2><p class="fn-popup__text--subline">Want to win one of our awesome Tower shirts?<br><b>Tell your friends about the First Aid Kit!</b></p><span class="fn-popup__image"><img src="' + FN.config.urls.base + 'assets/img/popups/tower-shirts@2x.png" width="360" /></span>',
      'action-button': 'Share on Twitter',
      'footer': 'We\'ll pick 4 winners every month who share this tweet!<br>Follow <a href="http://www.twitter.com/gittower" target="_blank">@gittower</a> to be notified if you win!',
      'tweet': {'platform': 'twitter', 'url': '', 'text': "The First Aid Kit for Git - download the free videos and learn how to undo and fix mistakes with Git like a pro. https://bit.ly/git-first-aid-kit pic.twitter.com/wXRFQXXs6M via @gittower #learngit"}
    }
  ]
};
FN.popupConfig.addPopupConfig(incentivePopup);



$(document).ready(function(){
  /*********** Configure Analytics Event Tracking */
  var contentAnalyticsEvents = [
    /* Newsletter Subscription */
    { 'config': { 'selector': '.body--default .newsletter-form.analytics--submit', 'triggerOnlyOnce': true },
      'event':  { 'eventCategory': 'newsletter', 'eventAction': 'signup', 'eventLabelSuffix': 'content' }
    },
    /* Header + Footer Links to Tower Site */
    { 'config': { 'selector': '#about .analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'footer/about' }
    },
    { 'config': { 'selector': '#header .tower-branding .analytics--click', 'waitBeforeDefault': true },
      'event':  { 'eventCategory': 'page-interaction', 'eventAction': 'landing-page', 'eventLabelSuffix': 'header/about' }
    },
    /* Content / Cheat Sheet Downloads */
    { 'config': { 'selector': '.incentive-download--incentive_webopti .analytics--click' },
      'event':  { 'eventCategory': 'content', 'eventAction': 'download', 'eventLabelSuffix': 'website-optimization-toolkit' }
    }
  ];
  FN.analytics.addConfiguredEvents(contentAnalyticsEvents);



  /************* Fade-In Animations */
  $(document).on('scroll', function(){
    $('.content__description, .content__visual, .content__background, #testimonials-container .frame').each(function(index, item){
      if(FN.helpers.isVisibleInViewport({ element: $(item), minimumVisiblePixels: 75 })){
        $(item).removeClass('hidden').addClass('visible');
      }
    });
  })
  
});
